/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';
import { Text } from 'components';
import { appConfig } from 'config/app';
import { theme, toRem } from 'design';

const LegalText = styled.section`
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: ${toRem(theme.space['3xl'])};
  text-align: center;

  a {
    color: ${theme.color.neutral[800]};
  }
`;

const SignUpTerms: React.FC = () => (
  <LegalText>
    <Text size="small">
      By signing up, you agree to our{' '}
      <a data-cy="terms-of-service" target="_blank" rel="noopener noreferrer" href={appConfig.LINKS.TERMS_OF_USE}>
        Terms of Use
      </a>{' '}
      &{' '}
      <a data-cy="privacy-policy" target="_blank" rel="noopener noreferrer" href={appConfig.LINKS.PRIVACY_POLICY}>
        Privacy Policy
      </a>
      .
    </Text>
  </LegalText>
);

export default SignUpTerms;
